import React from "react";
import { useLocationContext } from "context/LocationContext";
import RegionalOhlgsReport from "./components/RegionalOhlgsReport";
import DistrictOhlgsReport from "./components/DistrictOhlgsReport";

function UnsupportedLevelState() {
  return (
    <div className="main-content">
      <div className="card">
        <h2 className="mb-2 text-xl font-semibold text-foreground">OHLGS Report Not Available</h2>
        <p className="text-muted-foreground">
          OHLGS assessment is currently available for region and district context only.
        </p>
      </div>
    </div>
  );
}

export default function AutomatedReportGenerationSystem() {
  const { currentLocation } = useLocationContext();

  if (currentLocation?.level === "region") {
    return <RegionalOhlgsReport />;
  }

  if (currentLocation?.level === "district") {
    return <DistrictOhlgsReport />;
  }

  return <UnsupportedLevelState />;
}
